import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { updateAboutHeaderSection } from "../../api/apiAboutHeader";

export const useUpdateAboutHeaderSection = () => {
    const queryClient = useQueryClient();
    const { i18n } = useTranslation();
    const isArabic = (i18n.language || "en").startsWith("ar");

    const mutation = useMutation({
        mutationFn: (data) => updateAboutHeaderSection(data),
        onSuccess: (response) => {
            queryClient.invalidateQueries({ queryKey: ["about-header-section"] });
            toast.success(response?.message || (isArabic ? "تم تحديث رأس صفحة من نحن" : "About Header updated"));
        },
        onError: (error) => {
            const message = error?.response?.data?.message || (isArabic ? "تعذر التحديث" : "Failed to update");
            toast.error(message);
        },
    });

    return mutation;
};
